export const WHATSAPP_CONTACTS = [
  {
    name: "Marta",
    phone: "11942992627",
    displayPhone: "(11) 94299-2627",
  },
  {
    name: "Robson",
    phone: "11975648252",
    displayPhone: "(11) 97564-8252",
  },
];

export function buildWhatsAppLink(phone, message = "") {
  const text = message ? `&text=${encodeURIComponent(message)}` : "";
  return `https://api.whatsapp.com/send?phone=55${phone}${text}`;
}
